<template>
    <main-layout class="outil-item">

        <app-header icon="tool">
            Outillage
        </app-header>

        <action-bar :back="{name: 'liste-outils'}">
            <a href="javascript: void 0" class="btn btn-full main-action" :class="outil.actif ? 'actif' : 'inactif'" @click.prevent="switchOutil">
                <i :class="outil.actif ? 'icon-valid' : 'icon-error'"></i>
                <span>
                    Outillage
                    <strong>{{ action }}</strong>
                </span>
            </a>
        </action-bar>

        <div class="wrap main-content">

            <h2>Informations sur votre <b v-if="outil.type_outil">{{ outil.type_outil.nom }}</b> :</h2><br>

            <form method="post" id="outil">

                <label>Marque</label>
                <input title="mark" type="text" name="marque" readonly :value="outil.marque">

                <label>Nom de l'appareil</label>
                <input title="appareilName" type="text" name="nom" readonly :value="outil.modele">

                <label>Numéro de série</label>
                <input title="idNumber" type="text" name="numero" readonly :value="outil.numero_serie">

                <label>Distributeur</label>
                <input title="dist" type="text" name="fournisseur" readonly :value="outil.magasin">

                <label>Date d'achat</label>
                <input title="buyAt" type="date" name="date_achat" id="date_achat" readonly v-model="dateAchat">

                <label>N°facture</label>
                <input title="invoiceNumber" type="text" name="facture_achat" id="facture_achat" readonly v-model="outil.facture_achat">

                <label>N°bon de livraison</label>
                <input title="deliveryAt" type="text" name="bon_livraison" id="bon_livraison" readonly v-model="outil.bon_livraison">

                <label>Dernier contrôle</label>
                <input title="lastControl" type="date" name="last_controle" id="last_controle" readonly :value="dateLastControle">
            </form>
        </div>

    </main-layout>
</template>

<script>

    import Outil from '../../js/models/Outil'

    export default {
        data() {
            return {
                outil: {}
            }
        },

        computed: {
            dateLastControle: function () {
                return moment(this.outil.date_last_controle).format('Y-MM-DD')
            },

            dateAchat(){
                return moment(this.outil.date_achat).format('Y-MM-DD')
            },

            action(){
                if(this.outil.actif === true){
                    return "activé"
                } else {
                    return "désactivé"
                }
            }
        },
        props: {},
        methods: {
            getOutil() {
                let vueInstance = this;
                let key = this.$route.params.id;

                Outil
                    .getOutil(key)
                    .then(res => {
                        vueInstance.outil = res
                    })
                    .catch()
            },

            switchOutil() {
                if (this.outil.actif === true) {

                    this.outil.actif = false;
                    Outil.updateOffline(this.outil.id, this.outil)
                } else {
                    this.outil.actif = true;

                    if (this.outil.type_outil.nom === 'Détecteur de fuites manuel') {
                        Outil
                            .disableDetecteursExcept(this.outil.id)
                            .then(() => {
                                this.$emit('listUpdated')
                            })
                            .catch()
                    } else {
                        Outil.updateOffline(this.outil.id, this.outil)
                    }
                }
            }
        },

        mounted: function () {
            this.getOutil()


            let today = new Date();
            let dd = today.getDate();
            let mm = today.getMonth() + 1;
            let yyyy = today.getFullYear();

            if(dd < 10){
                dd = '0' + dd;
            }

            if(mm < 10){
                mm = '0' + mm;
            }

            yyyy = yyyy + 1;

            let maxDate = yyyy + '-' + mm + '-' + dd;
            document.getElementById('last_controle').setAttribute('max', maxDate)

        },
    }

</script>



// WEBPACK FOOTER //
// Outil.vue?1c02d414